import type { Key } from "../shared/i18n.js";
import type { IconName } from "../shared/Icon.js";

// Les destinations de la coquille (voir Shell.tsx) : onglets, et les écrans qui gardent la coquille.
export const TABS: { to: string; icon: IconName; label: Key; testId: string }[] = [
  { to: "/", icon: "projects", label: "nav.projects", testId: "tab-projects" },
  { to: "/idees", icon: "ideas", label: "nav.ideas", testId: "tab-ideas" },
  { to: "/commentaires", icon: "chat", label: "nav.comments", testId: "tab-comments" },
];
// La Bibliothèque et Inspiration (les styles) n'ont plus d'onglet : on y entre par Réglages, l'accueil vide ou
// le choix du style. Elles gardent la coquille pour qu'on puisse en revenir.
export const SPACES = [...TABS.map((x) => x.to), "/inspiration", "/bibliotheque", "/moi"];
